import actions from './contractsActions'
import mutations from './contractsMutations'
import state from './contractsState'
import getters from './contractsGetters'

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
}
